<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emListFilter" :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                           :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryManualCheckResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                        :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                        :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                        :entity="modelName"
                        :inlineActionsDisabled="prop_inline!=='1'" with-custom-row-actions-first-column
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                <template #left-header>
                  <b-button
                      :disabled="actionDisabled('selectOne')"
                      size="sm"
                      variant="outline-primary"
                      @click="openInputDialog()"
                  >
                    入库
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('selectOne')"
                      size="sm"
                      variant="outline-primary"
                      @click="openOutputDialog()"
                  >
                    出库
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openBatchOutputDialog()"
                  >
                    批量出库
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      class="btn-size"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateStorageType()"
                  >
                    更改存储类型
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      class="btn-size"
                      size="sm"
                      v-bind:class="'btn btn-outline-primary btn-sm'"
                      variant="outline-primary"
                      @click="openUpdateMaterialType()"
                  >
                    更改物料类型
                  </b-button>
                  <b-button :disabled="actionDisabled('select')"
                            class="btn-size"
                            size="sm"
                            v-bind:class="'btn btn-outline-primary btn-sm'"
                            variant="outline-primary"
                            @click="openUpdateStoreKeeper()"
                  >
                    更改库管员
                  </b-button>
                  <!--                  <b-button :disabled="actionDisabled('select')"-->
                  <!--                            class="btn-size"-->
                  <!--                            size="sm"-->
                  <!--                            v-bind:class="'btn btn-outline-primary btn-sm'"-->
                  <!--                            variant="outline-primary"-->
                  <!--                            @click="openUpdateRelatedDepart()"-->
                  <!--                  >-->
                  <!--                    更改关联部门-->
                  <!--                  </b-button>-->
                  <b-button :disabled="actionDisabled('select')"
                            class="btn-size"
                            size="sm"
                            v-bind:class="'btn btn-outline-primary btn-sm'"
                            variant="outline-primary"
                            @click="openUpdateStorageStartTime()"
                  >
                    更改存储开始时间
                  </b-button>
                  <b-button :disabled="actionDisabled('select')"
                            class="btn-size"
                            size="sm"
                            v-bind:class="'btn btn-outline-primary btn-sm'"
                            variant="outline-primary"
                            @click="openUpdateComments()"
                  >
                    更改备注2
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateWarehouseOrStoreLocation()"
                  >
                    修改库房/库位
                  </b-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateCurrentQuantityOrUnit()"
                  >
                    修改当前库存数/单位
                  </b-button>
                  <em-button :disabled="actionDisabled('select')"
                             :showName="true"
                             custom-label="更改关联部门"
                             type="search"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="emDeptUserSelectModalVisible = true"
                  >
                  </em-button>
                </template>
                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                  <b-button-group>
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="gotoInputRecord(customRowScope.row)"
                    >
                      入库记录
                    </b-button>
                    <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="gotoOutputRecord(customRowScope.row)"
                    >
                      出库记录
                    </b-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="inputDialogVisible" title="入库" width="30%"
               @close='clearInputQuantity'>
      <el-form ref="inputForm" :model="inputForm" :rules="inputRules" label-width="auto">
        <el-form-item label="入库量" prop="inputQuantity">
          <el-input v-model="inputForm.inputQuantity" type="number"></el-input>
        </el-form-item>
        <el-form-item label="入库时间" prop="inputTime">
          <el-date-picker v-model="inputForm.inputTime" placeholder="选择日期时间" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="inputForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="inputDialogVisible = false">取 消</el-button>
        <el-button :disabled="disableInput" type="primary" @click="materialIncoming()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="outputDialogVisible" title="出库" width="30%"
               @close='clearOutputQuantity'>
      <el-form ref="outputForm" :model="outputForm" :rules="outputRules" label-width="auto">
        <el-form-item label="出库量" prop="outputQuantity">
          <el-input v-model="outputForm.outputQuantity" type="number"></el-input>
        </el-form-item>
        <el-form-item label="出库时间" prop="outputTime">
          <el-date-picker v-model="outputForm.outputTime" placeholder="选择日期时间" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="物料去向" prop="destination">
          <el-input v-model="outputForm.destination" type="text"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="outputForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outputDialogVisible = false">取 消</el-button>
        <el-button :disabled="disableOutput" type="primary" @click="materialExport()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="batchOutputDialogVisible" title="批量出库" width="30%"
               @close='clearBatchOutputQuantity'>
      <el-form ref="batchOutputForm" :model="batchOutputForm" :rules="batchOutputRules" label-width="auto">
        <el-form-item label="出库时间" prop="outputTime">
          <el-date-picker v-model="batchOutputForm.outputTime" placeholder="选择日期时间" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="物料去向" prop="destination">
          <el-input v-model="batchOutputForm.destination" type="text"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="batchOutputForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchOutputDialogVisible = false">取 消</el-button>
        <el-button :disabled="disableBatchOutput" type="primary" @click="materialBatchOutput()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateStorageTypeVisible" title="批量更改存储类型"
               width="30%" z-index="1000" @close='clearUpdateStorageType'>
      <el-form ref="updateStorageTypeForm" :model="updateStorageTypeForm" :rules="updateStorageTypeRules"
               label-width="auto">
        <!--        <el-form-item label="存储类型" prop="storageType">-->
        <!--          <el-select v-model="updateStorageTypeForm.storageType" placeholder="请选择">-->
        <!--            <el-option-->
        <!--                v-for="storageType in storageTypeOptions"-->
        <!--                :key="storageType.value"-->
        <!--                :label="storageType.label"-->
        <!--                :value="storageType.value"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <b-form-input
            id="storageTypeSelector"
            v-model="updateStorageTypeForm.storageTypeId"
            class="form-control col-2 storage-type"
            placeholder="请选择存储类型"
            plaintext
            type="text"
            @click="$refs.storageTypeSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.storageTypeList"
                 :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateStorageTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateStorageType()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="storageTypeSelector" entity="sithMesInventoryManualStorageType"
                                             @entityModalSelectSelected="updateStorageType">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateMaterialTypeVisible" title="批量更改物料类型"
               width="30%" z-index="1000" @close='clearUpdateMaterialType'>
      <el-form ref="updateMaterialTypeForm" :model="updateMaterialTypeForm" :rules="updateMaterialTypeRules"
               label-width="auto">
        <b-form-input
            id="materialTypeSelector"
            v-model="updateMaterialTypeForm.materialTypeId"
            class="form-control col-2 material-type"
            placeholder="请选择物料类型"
            plaintext
            type="text"
            @click="$refs.materialTypeSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.materialTypeList"
                 :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateMaterialTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateMaterialType()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="materialTypeSelector" entity="sithMesInventoryManualMaterialType"
                                             @entityModalSelectSelected="updateMaterialType">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateStoreKeeperVisible" title="批量更改库管员"
               width="30%" z-index="1000" @close='clearUpdateStoreKeeper'>
      <el-form ref="updateStoreKeeperForm" :model="updateStoreKeeperForm" :rules="updateStoreKeeperRules"
               label-width="auto">
        <b-form-input
            id="storeKeeperSelector"
            v-model="updateStoreKeeperForm.storeKeeperLogin"
            class="form-control col-2 store-keeper"
            placeholder="请选择库管员"
            plaintext
            type="text"
            @click="$refs.storeKeeperSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.storeKeeperList"
                 :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateStoreKeeperVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateStoreKeeper()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="storeKeeperSelector" entity="emAclUser"
                                             @entityModalSelectSelected="updateStoreKeeper">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
    <!--    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateRelatedDepartVisible" title="批量更改关联部门"-->
    <!--               width="30%" z-index="1000" @close='clearUpdateRelatedDepart'>-->
    <!--      <el-form ref="updateRelatedDepartForm" :model="updateRelatedDepartForm" :rules="updateRelatedDepartRules"-->
    <!--               label-width="auto">-->
    <!--        <b-form-input-->
    <!--            id="relatedDepartSelector"-->
    <!--            v-model="updateRelatedDepartForm.relatedDepart"-->
    <!--            class="form-control col-2 related-depart"-->
    <!--            placeholder="请选择关联部门"-->
    <!--            plaintext-->
    <!--            type="text"-->
    <!--            @click="emDeptUserSelectModalVisible=true"-->
    <!--        ></b-form-input>-->
    <!--        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.relatedDepartList"-->
    <!--                 :select-mode='selectMode'-->
    <!--                 max-height="285px"-->
    <!--                 selectable-->
    <!--                 style="width:100%"-->
    <!--                 @row-selected="onRowSelected">-->
    <!--        </b-table>-->
    <!--      </el-form>-->
    <!--      <div slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="updateRelatedDepartVisible = false">取 消</el-button>-->
    <!--        <el-button type="primary" @click="batchUpdateRelatedDepart()">确认</el-button>-->
    <!--      </div>-->
    <!--      <em-modal-normal-input-entity-selector ref="relatedDepartSelector" entity="emAclDept"-->
    <!--                                             @entityModalSelectSelected="updateRelatedDepart">-->
    <!--      </em-modal-normal-input-entity-selector>-->
    <!--    </el-dialog>-->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateStorageStartTimeVisible" title="更新仓储开始时间" width="30%"
               @close='clearUpdateStorageStartTime'>
      <el-form ref="updateStorageStartTimeForm" :model="updateForm" :rules="updateStorageStartTimeRule"
               label-width="auto">
        <el-form-item label="仓储开始时间" prop="storageStartTime">
          <el-date-picker v-model="updateForm.storageStartTime" placeholder="选择日期时间" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateStorageStartTimeVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateStorageStartTime()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateCommentsVisible" title="更新备注2" width="30%"
               @close='clearUpdateComments'>
      <el-form ref="updateCommentsForm" :model="updateForm" :rules="updateCommentsRule" label-width="auto">
        <el-form-item label="备注2" prop="comments">
          <el-input v-model="updateForm.comments" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateCommentsVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateComments()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateWarehouseOrStoreLocationDialogVisible"
               title="批量修改库房/库位" width="30%"
               @close='clearUpdateWarehouseOrStoreLocation'>
      <el-form ref="updateWarehouseOrStoreLocationForm" :model="updateWarehouseOrStoreLocationForm"
               :rules="updateWarehouseOrStoreLocationRule" label-width="auto">
        <el-form-item label="库房名称">
          <el-input v-model="updateWarehouseOrStoreLocationForm.warehouse" type="text"></el-input>
        </el-form-item>
        <el-form-item label="库位名称">
          <el-input v-model="updateWarehouseOrStoreLocationForm.storeLocation" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateWarehouseOrStoreLocationFormDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateWarehouseOrStoreLocation()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateCurrentQuantityOrUnitDialogVisible"
               title="批量当前库存数/单位" width="30%"
               @close='clearUpdateCurrentQuantityOrUnit'>
      <el-form ref="updateCurrentQuantityOrUnitForm" :model="updateCurrentQuantityOrUnitForm"
               :rules="updateCurrentQuantityOrUnitRule" label-width="auto">
        <el-form-item label="当前库存数">
          <el-input v-model="updateCurrentQuantityOrUnitForm.currentQuantity" type="number"></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="updateCurrentQuantityOrUnitForm.unit" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateCurrentQuantityOrUnitFormDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateCurrentQuantityOrUnit()">确认</el-button>
      </div>
    </el-dialog>

    <!--    和佳北确认过，在SITH项目中，部门和工厂模型指向同一个表，因此手工账的关联部门可以直接使用工厂模型（Location），Department已弃用。-->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateRelatedDepartVisible" title="更改关联部门"
               width="30%" @close='clearUpdateRelatedDepart'>
      <el-form ref="updateRelatedDepartForm" :model="updateRelatedDepartForm" :rules="updateRelatedDepartRules"
               label-width="auto">

        <el-form-item label="部门ID" prop="locationId">
          <el-input v-model="updateRelatedDepartForm.relatedDepart" :disabled="true">
            <el-button slot="append" type="success" @click="emDeptUserSelectModalVisible=true">选择部门
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <b-modal v-model="emDeptUserSelectModalVisible" scrollable title="选择工位" @ok="batchUpdateRelatedDepart">
      <location-tree ref="locationTree"></location-tree>
    </b-modal>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Lin
// Date 2022-06-15 16:55:02

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonGotoMixin from "@/mixin/em/common/goto";
// import EmDeptUserTree from "@/components/em/EmBusiness/deptUserTree";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
import LocationTree from "@/components/em/EmBusiness/locationTree";

export default {
  // components: {EmDeptUserTree, EmModalNormalInputEntitySelector, LocationTree},
  components: {EmModalNormalInputEntitySelector, LocationTree},
  name: "sithMesInventoryManualCheckListView",
  mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, commonViewsUtil, emCommonGotoMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"];
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
    disableInput() {
      if (this.inputForm.inputQuantity <= 0) {
        return true;
      }

      return false;
    },
    disableOutput() {
      if (this.outputForm.outputQuantity <= 0) {
        return true;
      }

      return false;
    },
    disableBatchOutput() {
      if (this.batchOutputForm.outputQuantity <= 0) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      inputDialogVisible: false,
      outputDialogVisible: false,
      batchOutputDialogVisible: false,
      inputForm: {
        inputQuantity: '',
        inputTime: '',
        remark: ''
      },
      outputForm: {
        outputQuantity: '',
        outputTime: '',
        destination: '',
        remark: ''
      },
      batchOutputForm: {
        outputTime: '',
        destination: '',
        remark: ''
      },
      inputRules: {
        inputQuantity: [{required: true, message: '入库量不能为空'}],
      },
      outputRules: {
        outputQuantity: [{required: true, message: '出库量不能为空'}],
        destination: [{required: true, message: '物料去向不能为空'}],
      },
      batchOutputRules: {
        destination: [{required: true, message: '物料去向不能为空'}],
      },
      updateStorageTypeVisible: false,
      updateStorageTypeForm: {
        storageTypeId: ''
      },
      updateStorageTypeRules: {storageType: [{required: true, message: '请选择存储类型！'}]},
      updateMaterialTypeVisible: false,
      updateMaterialTypeForm: {
        materialTypeId: ''
      },
      updateMaterialTypeRules: {materialTypeId: [{required: true, message: '请选择物料类型！'}]},
      updateStoreKeeperVisible: false,
      updateStoreKeeperForm: {
        storeKeeperLogin: ''
      },
      updateStoreKeeperRules: {storeKeeperLogin: [{required: true, message: '请选择库管员！'}]},
      updateRelatedDepartVisible: false,
      updateRelatedDepartForm: {
        relatedDepart: ''
      },
      updateRelatedDepartRules: {relatedDepart: [{required: true, message: '请选择关联部门！'}]},

      updateStorageStartTimeVisible: false,
      updateCommentsVisible: false,
      updateForm: {
        storageStartTime: '',
        comments: ''
      },
      updateStorageStartTimeRule: {storageStartTime: [{required: true, message: '请选择仓储开始时间！'}]},
      updateCommentsRule: {comments: [{required: true, message: '请输入备注2 ！'}]},

      updateWarehouseOrStoreLocationDialogVisible: false,
      updateWarehouseOrStoreLocationForm: {
        warehouse: '',
        storeLocation: '',
      },
      updateWarehouseOrStoreLocationRule: {warehouse: [{required: true, message: '请输入库房名称！'}]},
      emDeptUserSelectModalVisible: false,

      updateCurrentQuantityOrUnitDialogVisible: false,
      updateCurrentQuantityOrUnitForm: {
        currentQuantity: '',
        unit: '',
      },
      updateCurrentQuantityOrUnitRule: {currentQuantity: [{required: true, message: '请输入当前库存数！'}]},
    }
  },
  methods: {
    gotoInputRecord(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesInventoryManualInput"
          , {manualCheckIdFilter: row.id}
          , {manualCheckId: row.id}, false, {})
    },
    gotoOutputRecord(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesInventoryManualOutput"
          , {manualCheckIdFilter: row.id}
          , {manualCheckId: row.id}, false, {})
    },
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    openInputDialog() {
      this.inputDialogVisible = true;
    },
    openOutputDialog() {
      this.outputDialogVisible = true;
    },
    openBatchOutputDialog() {
      this.batchOutputDialogVisible = true;
    },
    clearInputQuantity() {
      this.inputForm.inputQuantity = '';
      this.inputForm.inputTime = '';
      this.inputForm.remark = '';
      this.$refs["inputForm"].resetFields();
    },
    clearOutputQuantity() {
      this.outputForm.outputQuantity = '';
      this.outputForm.outputTime = '';
      this.outputForm.destination = '';
      this.outputForm.remark = '';
      this.$refs["outputForm"].resetFields();
    },
    clearBatchOutputQuantity() {
      this.batchOutputForm.outputTime = '';
      this.batchOutputForm.destination = '';
      this.batchOutputForm.remark = '';
      this.$refs["batchOutputForm"].resetFields();
    },
    materialIncoming() {
      let self = this;
      self.$refs["inputForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/materialIncoming?id=${this.selectIds}&quantity=${self.inputForm.inputQuantity}&time=${self.inputForm.inputTime}&remark=${self.inputForm.remark}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "入库成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "入库失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.inputDialogVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    materialExport() {
      let self = this;
      self.$refs["outputForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/materialExport?id=${this.selectIds}&quantity=${self.outputForm.outputQuantity}&time=${self.outputForm.outputTime}&remark=${self.outputForm.remark}&dest=${self.outputForm.destination}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "出库成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "出库失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.outputDialogVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })

    },
    materialBatchOutput() {
      let self = this;
      self.$refs["batchOutputForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/materialBatchOutput?ids=${this.selectIds}&time=${self.batchOutputForm.outputTime}&dest=${self.batchOutputForm.destination}&remark=${self.batchOutputForm.remark}`
          console.log("url === " + url);
          self.$_emApiMixin_post(url, self.batchOutputForm)
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量出库成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量出库失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.batchOutputDialogVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })

    },

    updateStorageType(selectRow) {
      console.log(selectRow)
      this.updateStorageTypeForm.storageTypeId = selectRow.id;
    },

    updateMaterialType(selectRow) {
      console.log(selectRow)
      this.updateMaterialTypeForm.materialTypeId = selectRow.id;
    },
    updateStoreKeeper(selectRow) {
      console.log(selectRow)
      this.updateStoreKeeperForm.storeKeeperLogin = selectRow.loginName;
    },
    updateRelatedDepart(selectRow) {
      console.log(selectRow)
      this.updateRelatedDepartForm.relatedDepart = selectRow.id;
    },
    openUpdateStorageType() {
      this.updateStorageTypeVisible = true;
    },
    clearUpdateStorageType() {
      this.updateStorageTypeForm.storageTypeId = ''
      this.storageTypeList = [];
    },
    batchUpdateStorageType() {
      let self = this;
      this.$refs["updateStorageTypeForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateStorageType?ids=${this.selectIds}&storageTypeId=${self.updateStorageTypeForm.storageTypeId}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量更新存储类型成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量更新存储类型失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateStorageTypeVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    openUpdateMaterialType() {
      this.updateMaterialTypeVisible = true;
    },
    clearUpdateMaterialType() {
      this.updateMaterialTypeForm.materialTypeId = ''
      this.materialTypeList = [];
    },
    batchUpdateMaterialType() {
      let self = this;
      this.$refs["updateMaterialTypeForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateMaterialType?ids=${this.selectIds}&materialTypeId=${self.updateMaterialTypeForm.materialTypeId}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量更新物料类型成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量更新物料类型失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateMaterialTypeVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    openUpdateStoreKeeper() {
      this.updateStoreKeeperVisible = true;
    },
    clearUpdateStoreKeeper() {
      this.updateStoreKeeperForm.storeKeeperLogin = ''
      this.storeKeeperList = [];
    },
    batchUpdateStoreKeeper() {
      let self = this;
      this.$refs["updateStoreKeeperForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateStoreKeeper?ids=${this.selectIds}&storeKeeperLogin=${self.updateStoreKeeperForm.storeKeeperLogin}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量更新库管员成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量更新库管员失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateStoreKeeperVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    openUpdateRelatedDepart() {
      this.updateRelatedDepartVisible = true;
    },
    clearUpdateRelatedDepart() {
      this.updateRelatedDepartForm.relatedDepart = ''
      this.relatedDepartList = [];
    },
    batchUpdateRelatedDepart() {
      //和佳北确认过，在SITH项目中，部门和工厂模型指向同一个表，因此手工账的关联部门可以直接使用工厂模型（Location），Department已弃用。
      let deptId = this.$refs.locationTree.getLocationIds();
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateRelatedDepart?ids=${this.selectIds}&relatedDepart=${deptId}`
      self.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              self.$message({
                message: "批量更改关联部门成功",
                type: "success",
              });

              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "批量更改关联部门失败",
                type: "error",
              });
            }
          })
          .finally(() => this.updateRelatedDepartVisible = false)
    },
    openUpdateStorageStartTime() {
      this.updateStorageStartTimeVisible = true;
    },
    clearUpdateStorageStartTime() {
      this.updateForm.storageStartTime = ''
    },
    batchUpdateStorageStartTime() {
      let self = this;
      this.$refs["updateStorageStartTimeForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateStorageStartTime?ids=${this.selectIds}&storageStartTime=${self.updateForm.storageStartTime}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新仓储开始时间成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新仓储开始时间失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateStorageStartTimeVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    openUpdateComments() {
      this.updateCommentsVisible = true;
    },
    clearUpdateComments() {
      this.updateForm.comments = ''
    },
    batchUpdateComments() {
      let self = this;
      this.$refs["updateCommentsForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateComments?ids=${this.selectIds}&comments=${self.updateForm.comments}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新备注2成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新备注2失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateCommentsVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    openUpdateWarehouseOrStoreLocation() {
      this.updateWarehouseOrStoreLocationDialogVisible = true;
    },
    clearUpdateWarehouseOrStoreLocation() {
      this.updateWarehouseOrStoreLocationForm.warehouse = '';
      this.updateWarehouseOrStoreLocationForm.storeLocation = ''
    },
    batchUpdateWarehouseOrStoreLocation() {
      let self = this;
      this.$refs["updateWarehouseOrStoreLocationForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateWarehouseOrStoreLocation?ids=${this.selectIds}&warehouse=${self.updateWarehouseOrStoreLocationForm.warehouse}&storeLocation=${self.updateWarehouseOrStoreLocationForm.storeLocation}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量修改库房名称/库位名称成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量修改库房名称/库位名称失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateWarehouseOrStoreLocationDialogVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },

    openUpdateCurrentQuantityOrUnit() {
      this.updateCurrentQuantityOrUnitDialogVisible = true;
    },
    clearUpdateCurrentQuantityOrUnit() {
      this.updateCurrentQuantityOrUnitForm.currentQuantity = '';
      this.updateCurrentQuantityOrUnitForm.unit = ''
    },
    batchUpdateCurrentQuantityOrUnit() {
      let self = this;
      this.$refs["updateCurrentQuantityOrUnitForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateCurrentQuantityOrUnit?ids=${this.selectIds}&currentQuantity=${self.updateCurrentQuantityOrUnitForm.currentQuantity}&unit=${self.updateCurrentQuantityOrUnitForm.unit}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "批量修改当前库存数/单位成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "批量修改当前库存数/单位失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateCurrentQuantityOrUnitDialogVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
  }
};
</script>
